import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {submitBankAccount, updateBankAccount} from "../../services/bank_account/bank_account";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import Validator from "../../helper/validator/Validator";
import {checkAll} from "../../helper/validator/Check";
import {toast} from "react-toastify";

export function BankAccountForm({bankAccount, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [title, setTitle] = useState("")
  const [bankName, setBankName] = useState("")
  const [card, setCard] = useState("");
  const [sheba, setSheba] = useState("");
  const [status, setStatus] = useState(false);

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setId((bankAccount && bankAccount.id) || null);
    setTitle((bankAccount && bankAccount.title) || "");
    setBankName((bankAccount && bankAccount.bank_name) || "");
    setCard((bankAccount && bankAccount.card) || "");
    setSheba((bankAccount && bankAccount.sheba) || "");
    setStatus(!!(bankAccount && bankAccount.status && bankAccount.status === 'enable'));
  }, [bankAccount]);

  const save = async () => {
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return
    }

    const data = {
      id: id,
      title: title,
      bank_name: bankName,
      card: card,
      sheba: sheba.length > 0 ? `IR${sheba.replace("IR", "")}` : "",
      status: status ? "enable" : "disable"
    };
    let result;

    if (!id) {
      result = await submitBankAccount(data);
    } else {
      result = await updateBankAccount(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <ValidatorProvider>
      <>

        <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>ویرایش/جدید</Typography>
          </DialogHeader>
          <DialogBody className="grid grid-cols-1 gap-4 overflow-y-scroll">

            <div className="flex flex-col w-full mb-4">
              <Input
                className="flex flex-row"
                variant="standard"
                value={title}
                label={Dict('title')}
                placeholder={Dict('title')}
                onChange={(e) => {
                  setTitle(e.target.value)
                }}
              />
              <Validator isChecked={isChecked} state={title} rules="required"/>
            </div>

            <div className="flex flex-col w-full mb-4">
              <Input
                className="flex flex-row"
                variant="standard"
                value={bankName}
                label="نام بانک"
                placeholder="نام بانک"
                onChange={(e) => {
                  setBankName(e.target.value)
                }}
              />
              <Validator isChecked={isChecked} state={bankName} rules="required"/>
            </div>

            <div className="flex flex-col w-full mb-4">
              <Input
                className="flex flex-row"
                variant="standard"
                value={card}
                label="شماره کارت"
                placeholder="شماره کارت"
                onChange={(e) => {
                  setCard(e.target.value)
                }}
              />
              <Validator isChecked={isChecked} state={card} rules="required|len=16"/>
            </div>

            <div className="flex flex-col w-full mb-4">
              <div className="flex flex-row w-full">
                <Input
                  className="flex flex-row rounded-tl-none rounded-bl-none border-black"
                  variant="standard"
                  value={`IR${sheba}`}
                  label="شماره شبا"
                  placeholder="شماره شبا"
                  onChange={(e) => {
                    setSheba(e.target.value.replace("IR", ""))
                  }}
                />
              </div>
              <Validator isChecked={isChecked} state={sheba} rules="required|len=24"/>
            </div>

            <div className="">
              <Switch
                label={
                  <Typography color="blue-gray" className="font-medium">
                    فعال/غیرفعال
                  </Typography>
                }
                checked={status}
                onChange={(e) => {
                  setStatus(e.target.checked)
                }}
                labelProps={{className: "mx-4"}}
              />
            </div>
          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
          </DialogFooter>
        </Dialog>

      </>
    </ValidatorProvider>
  );
}